import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Link } from 'react-router-dom';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './Map.css';
import { getMapData } from '../../api';
// Leaflet default marker icon fix
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Map = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // const [cities, setCities] = useState([
  //   {
  //     id: 1,
  //     name: "İstanbul",
  //     position: [41.0082, 28.9784],
  //     articles: ["Makale 1", "Makale 2"]
  //   },
  //   {
  //     id: 2,
  //     name: "Ankara",
  //     position: [39.9334, 32.8597],
  //     articles: ["Makale 3"]
  //   },
  //   {
  //     id: 3,
  //     name: "İzmir",
  //     position: [38.4237, 27.1428],
  //     articles: ["Makale 4", "Makale 5", "Makale 6"]
  //   }
  // ]);

  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);

  const getAPI = async() => {
    try {
      setLoading(true);
      setError(null);
      const res = await getMapData();
      console.log("Map data response:", res);
      console.log("Response type:", typeof res);
      console.log("Response status:", res?.status);
      console.log("Response data:", res?.data);
      console.log("Response data type:", typeof res?.data);
      console.log("Response data length:", Array.isArray(res?.data) ? res.data.length : "Not an array");
      
      let mapData = [];
      
      if (res && res.status && Array.isArray(res.data)) {
        mapData = res.data;
      } else if (res && Array.isArray(res)) {
        // Direct array response
        mapData = res;
      } else {
        console.warn("Map data is not in expected format:", res);
        mapData = [];
      }
      
      // Veri formatını API'ye göre düzenle
      // Her obje bir makale, bunları şehirlere göre grupla
      const cityGroups = {};
      
      mapData.forEach((article) => {
        if (!article.lat || !article.lng) return;
        
        const positionKey = `${article.lat},${article.lng}`;
        
        if (!cityGroups[positionKey]) {
          // Şehir ismini makale başlığından çıkar
          let cityName = article.title;
          
          // Yaygın şehir isimlerini çıkar
          const cityPatterns = [
            /(.+?)\s+(İli|Yöresi|İlçesi)/i,
            /(.+?)\s+Geleneksel/i,
            /(.+?)\s+İli/i,
            /(.+?)\s+Yöresi/i
          ];
          
          for (const pattern of cityPatterns) {
            const match = article.title.match(pattern);
            if (match && match[1]) {
              cityName = match[1].trim();
              break;
            }
          }
          
          cityGroups[positionKey] = {
            id: `city_${positionKey}`,
            name: cityName,
            position: [parseFloat(article.lat), parseFloat(article.lng)],
            articles: []
          };
        }
        
        cityGroups[positionKey].articles.push({
          id: article.id,
          title: article.title,
          writerName: article.writerName
        });
      });
      
      // Grupları array'e çevir
      mapData = Object.values(cityGroups);
      
      // Veri formatını kontrol et ve logla
      console.log("Processed map data:", mapData);
      console.log("First city object keys:", mapData.length > 0 ? Object.keys(mapData[0]) : "No data");
      
      mapData.forEach((city, index) => {
        console.log(`City ${index}:`, {
          id: city.id,
          name: city.name,
          title: city.title,
          cityName: city.cityName,
          position: city.position,
          lat: city.lat,
          lng: city.lng,
          latitude: city.latitude,
          longitude: city.longitude,
          articles: city.articles,
          items: city.items,
          allKeys: Object.keys(city)
        });
      });
      
      setCities(mapData);
      console.log(`Total cities loaded: ${mapData.length}`);
    } catch (err) {
      console.error("Error fetching map data:", err);
      setError("Harita verileri yüklenirken bir hata oluştu.");
      setCities([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAPI(); 
  }, [])
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMarkerClick = (city) => {
    setSelectedCity(city);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCity(null);
  };

  return (
    <div className="map-container">
      {loading && (
        <div className="map-loading">
          <p>Harita verileri yükleniyor...</p>
        </div>
      )}
      
      {error && (
        <div className="map-error">
          <p>{error}</p>
        </div>
      )}
      
      <MapContainer
        center={[39.0, 35.0]}
        zoom={isMobile ? 5 : 7}
        scrollWheelZoom={false}
        dragging={isMobile}
        zoomControl={false}
        doubleClickZoom={false}
        className="map"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {cities && Array.isArray(cities) ? cities.map((city, index) => {
          // Güvenlik kontrolü: city objesi ve gerekli alanlar var mı?
          if (!city || !city.id) {
            console.log("Skipping city - missing id:", city);
            return null;
          }
          
          // Position formatını kontrol et ve düzelt
          let position = null;
          
          if (city.position && Array.isArray(city.position) && city.position.length >= 2) {
            position = [parseFloat(city.position[0]), parseFloat(city.position[1])];
          } else if (city.lat && city.lng) {
            position = [parseFloat(city.lat), parseFloat(city.lng)];
          } else if (city.latitude && city.longitude) {
            position = [parseFloat(city.latitude), parseFloat(city.longitude)];
          } else {
            console.log("Skipping city - invalid position:", city);
            return null;
          }
          
          // Position değerlerinin geçerli olup olmadığını kontrol et
          if (isNaN(position[0]) || isNaN(position[1])) {
            console.log("Skipping city - invalid position values:", position);
            return null;
          }
          
          console.log(`Rendering marker for ${city.name} at position:`, position);
          console.log(`Articles for ${city.name}:`, city.articles);
          
          return (
            <Marker 
              key={city.id} 
              position={position}
              eventHandlers={{
                click: () => handleMarkerClick(city)
              }}
            />
          );
        }).filter(marker => marker !== null) : null}
        
        {/* Debug: Render edilen marker sayısını logla */}
        {console.log(`Rendered ${cities && Array.isArray(cities) ? cities.length : 0} cities`)}
      </MapContainer>

      {/* Modal */}
      {showModal && selectedCity && (
        <div className="map-modal-overlay" onClick={handleCloseModal}>
          <div className="map-modal" onClick={(e) => e.stopPropagation()}>
            <div className="map-modal-header">
              <h2 className="map-modal-title">{selectedCity.name}</h2>
              <div className="map-modal-stats">
                {selectedCity.articles.length} makale • {new Set(selectedCity.articles.map(a => a.writerName)).size} yazar
              </div>
              <button className="map-modal-close" onClick={handleCloseModal}>×</button>
            </div>
            <div className="map-modal-content">
              {selectedCity.articles.map((article, index) => (
                <Link 
                  key={article.id} 
                  to={`/article/${article.id}`}
                  className="map-modal-item"
                >
                  <div className="map-modal-item-number">{index + 1}</div>
                  <div className="map-modal-item-content">
                    <div className="map-modal-item-title">{article.title}</div>
                    <div className="map-modal-item-author">{article.writerName}</div>
                  </div>
                  <div className="map-modal-item-arrow">→</div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Map; 
